module.exports = __webpack_public_path__ + "media/entities/1103-27c65ca2.png";